@import '~style-sheet-helpers/core.less';

.body {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 8px;
  padding: 16px 16px 64px;
  line-height: 1.5;
}
